module.exports = __webpack_public_path__ + "img/img53.8a77affa.png";